import { SugarMoneyApiCheckTransactionStatusType } from 'types/api-internal';
import {
  SugarMoneyApiSubmitPayoutResponseType,
  SugarMoneyTransactionStatusEnum,
} from '../types/common';

export const checkTransactionLoop = async ({
  signature,
  checkTransactionStatus,
}: {
  signature: string;
  checkTransactionStatus: SugarMoneyApiCheckTransactionStatusType;
}): Promise<SugarMoneyApiSubmitPayoutResponseType> => {
  while (true) {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const checkTransactionData = await checkTransactionStatus({
      signature,
    });

    if (checkTransactionData.status !== SugarMoneyTransactionStatusEnum.Processing) {
      if (checkTransactionData.status === SugarMoneyTransactionStatusEnum.Success) {
        return checkTransactionData.signature;
      }
      throw new Error('Transaction failed or was dropped');
    }
  }
};
